import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Security } from "@okta/okta-react";
import { IntlProvider } from "react-intl";
import { Provider } from "react-redux";
import "semantic-ui-css/semantic.min.css";
import { ChakraProvider } from "@chakra-ui/react";

import { OktaAuth } from "@okta/okta-auth-js";
import { ApexUIProvider, theme } from "@apexinternal/ui-components";
import configureStore from "./store";
import { loadIntlMessages } from "./utils/intlHelpers";
import { App } from "./containers/App";
import { OKTA_CONFIG } from "./constants";
import { AuthProvider } from "./containers/contexts/auth/AuthContext";
import { PermissionsProvider } from "./containers/contexts/permissions/PermissionsContext";
import { RoutesEnum } from "./types/RoutesEnum";
import { SearchProvider } from "./containers/providers/SearchProvider";
import APITokenPersistence from "./components/APITokenPersistence";

// create the redux store with middlewares, e.g. redux-saga.
const store = configureStore();
const oktaAuth = new OktaAuth(OKTA_CONFIG);

ReactDOM.render(
  <Provider store={store}>
    <Security oktaAuth={oktaAuth}>
      <APITokenPersistence>
        <IntlProvider {...loadIntlMessages()}>
          <AuthProvider>
            <PermissionsProvider>
              <BrowserRouter basename={RoutesEnum.Root}>
                <ChakraProvider theme={theme}>
                  <ApexUIProvider>
                    <SearchProvider>
                      <App />
                    </SearchProvider>
                  </ApexUIProvider>
                </ChakraProvider>
              </BrowserRouter>
            </PermissionsProvider>
          </AuthProvider>
        </IntlProvider>
      </APITokenPersistence>
    </Security>
  </Provider>,
  document.getElementById("root")
);

if (window.Cypress) {
  window.store = store;
}
